export const isValidProfileImage = (profileImage) => {
  if (!profileImage || typeof profileImage !== "string") return false;

  const normalizedProfileImage = profileImage.trim().toLowerCase();

  return !["", "null", "undefined", "false", "nan"].includes(
    normalizedProfileImage
  );
};

export const buildUserProfileImageUrl = (
  backendUrl,
  companyId,
  profileImage,
  fallbackUrl
) => {
  if (companyId && isValidProfileImage(profileImage)) {
    if (/^https?:\/\//i.test(profileImage)) {
      return profileImage;
    }

    return `${backendUrl}/public/company${companyId}/user/${profileImage}`;
  }

  return fallbackUrl || `${backendUrl}/public/app/noimage.png`;
};
